/* eslint-disable import/no-anonymous-default-export */
export default (
  item = { success: null, error: null, updateMessage: null, data: [] },
  action
) => {
  switch (action.type) {
    case "STOCK_ITEMS":
      return { ...item, data: action.payload };
    case "CREATE_STOCK_ITEM":
      return { ...item, data: [...item.data, action.payload] };
    case "SUCCESS_CREATING_STOCK_ITEM":
      return {
        ...item,
        success: action.payload,
        error: null,
        updateMessage: null,
      };
    case "ERROR_CREATING_STOCK_ITEM":
      return {
        ...item,
        error: action.payload,
        success: null,
        updateMessage: null,
      };
    case "UPDATE_STOCK_ITEM":
      return {
        ...item,
        data: item.data.map((d) => (d._id === action.payload?._id ? action.payload : d)),
      };
    case "DELETE_STOCK_ITEM":
      return {
        ...item,
        data: item.data.filter((data) => data._id !== action.payload),
      };
    default:
      return item;
  }
};
